module.exports = __webpack_public_path__ + "media/images/faces/male/5-347c56563e59fd4cc9e3261e2aab55da.jpg";